/**
 * Stops a mouse wheel from silently editing a focused `<input type="number">`.
 *
 * Browsers treat a wheel over a focused number input as a spinner drag: the
 * value changes while the user only meant to scroll the page. On a POCK or a fee
 * form that quietly rewrites a quantity or an amount, and nothing on screen says
 * so — the subcontractor who reported stray groszy on a POCK blamed exactly this.
 *
 * Blurring on wheel drops the default action (an unfocused number input does not
 * spin) while leaving the page free to scroll.
 */
export function installNumberInputWheelGuard(target: Window = window): () => void {
  const onWheel = (e: Event) => {
    const el = target.document.activeElement;
    if (el instanceof HTMLInputElement && el.type === "number" && el === e.target) {
      el.blur();
    }
  };
  target.addEventListener("wheel", onWheel, { passive: true });
  return () => target.removeEventListener("wheel", onWheel);
}
